import { Button, Grid, TextField } from '@mui/material'
import { isEqual } from 'lodash'
import { memo } from 'react'
import { metodoPrograma } from '../../../components/api'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

const retornaLocalAtendimento = (u = []) => ({
  idVia: u?.[0] || undefined,
  nmVia: u?.[1] || undefined,
  dtExclusao: u?.[2] || undefined,
})

const createAgenda = z.object({
  idVia: z.number().optional(),
  nmVia: z.string().min(2, {
    message: 'Nome da agenda inválido',
  }),
  dtExclusao: z.string().optional(),
})

const Edicao = ({ dados, voltar }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(createAgenda),
    defaultValues: retornaLocalAtendimento(dados),
  })

  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
  }

  return (
    <form onSubmit={handleSubmit(salva)}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            {...register('nmVia')}
            label="Nome"
            fullWidth
            margin="dense"
            variant="outlined"
            error={!!errors.nmVia}
            helperText={errors.nmVia?.message}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ display: 'flex', flexDirection: 'row-reverse' }}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ margin: '5px' }}
          >
            Salvar
          </Button>
          <Button
            onClick={voltar}
            variant="contained"
            color="secondary"
            style={{ margin: '5px' }}
          >
            Cancelar
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default memo(Edicao, isEqual)
